module.exports = __webpack_public_path__ + "media/images/img/tag_company/ctc_tag-0aa4be8f98dc856f758ea13927b9b921.png";